import {StagingTitelineAppCasing} from "../types/StagingTitelineAppCasing";
import {CasingData} from "../types/CasingData";
import { getApiUrl } from '../config/api';

export const fetchCasingByPid = async (pid?: number, aid: number = -1): Promise<CasingData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineCasing/GetCasingByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No casing found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching casing for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppCasing[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((casing) => casing.DataSource === aid.toString());
        }

        return backendData.map((casing) => ({
            key: casing.CasId,
            cas_id: casing.CasId,
            pid: casing.Pid,
            hole_id: casing.HoleID,
            casing_type: casing.CasingType,
            casing_size: casing.CasingSize,
            depth_from: casing.DepthFrom,
            depth_to: casing.DepthTo,
        }));
    } catch (error) {
        console.error("Error in fetchCasingByPid API call:", error);
        return [];
    }
};

export const addCasingRow = async (casingRow: CasingData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineCasing/AddCasing');

    const cloudPayload = [
        {
            Pid: casingRow.pid ?? -1,
            HoleID: casingRow.hole_id,
            CasingType: casingRow.casing_type,
            CasingSize: casingRow.casing_size,
            DepthFrom: casingRow.depth_from,
            DepthTo: casingRow.depth_to,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Casing row added to cloud successfully.");
            return true;
        } else {
            console.error(
                "Failed to add casing row to cloud:",
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in addCasingRow API call:", error);
        return false;
    }
};

export const updateCasingRow = async (cas_id: number, updatedRow: CasingData) => {
    const apiUrl = getApiUrl(`/api/TitelineCasing/UpdateCasingByCasid/${cas_id}`);
    const cloudPayload = {
        HoleID: updatedRow.hole_id,
        CasingType: updatedRow.casing_type,
        CasingSize: updatedRow.casing_size,
        DepthFrom: updatedRow.depth_from,
        DepthTo: updatedRow.depth_to,
    };

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Casing row with CasId ${cas_id} updated successfully.`);
            return true;
        } else {
            console.error(
                `Failed to update casing row with CasId ${cas_id}:`,
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in updateCasingRow API call:", error);
        return false;
    }
};

export const deleteCasingByCasid = async (cas_id: number) => {
    const apiUrl = getApiUrl(`/api/TitelineCasing/DeleteCasingByCasid/${cas_id}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeleteCasingByCasid API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete casing row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteCasingByCasid API call:", error);
        return false;
    }
};




